import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageProvider';
export function Timeline() {
  const {
    t
  } = useLanguage();
  return <ol className="relative mt-8 space-y-8 border-l-2 border-ink/20 pl-6 sm:pl-8" data-id="element-126" data-mp="35xq9tp9rhjd2">
      {t.timeline.map((entry, i) => <motion.li key={entry.title} initial={{
      opacity: 0,
      x: -12
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.45,
      delay: i * 0.05,
      ease: 'easeOut'
    }} className="relative" data-id="element-127" data-mp="2w5kjsl32lc0i" data-mpi={i}>
          <span className="absolute -left-[calc(1.5rem+7px)] top-2 h-3 w-3 rounded-full border-2 border-paper bg-accent sm:-left-[calc(2rem+7px)]" aria-hidden="true" data-id="element-128" data-mp="2964xiklhwk7e" />
          <p className="font-sans text-[11px] font-bold uppercase tracking-[0.24em] text-accent" data-id="element-129" data-mp="7e06dbbtlqxq">
            {t.timelineStage} {String(i + 1).padStart(2, '0')}
          </p>
          <h3 className="mt-1 font-serif text-2xl font-bold tracking-tight" data-id="element-130" data-mp="2n77ozhvtomr2">{entry.title}</h3>
          <p className="mt-1.5 max-w-2xl text-[16px] leading-relaxed text-ink/85" data-id="element-131" data-mp="2i84kbyjr8ijm">{entry.text}</p>
        </motion.li>)}
    </ol>;
}